<template>
  <div class="billing-contacts">
    <div class="billing-contacts_header">
      <h1>Billing Contacts</h1>
      <div class="description">
        Please note, only Admins have the ability to access and make changes
        within an account.
      </div>
    </div>
    <div class="frameParent">
      <div
        class="frameGroup"
        v-for="contact of contacts"
        v-bind:key="contact.id"
      >
        <div class="frameContainer">
          <div class="frameDiv">
            <img
              class="frameChild"
              v-if="
                users.find(
                  (data) =>
                    data.name === contact.contactName &&
                    data.email === contact.contactEmail,
                ).image
              "
              :src="
                users.find(
                  (data) =>
                    data.name === contact.contactName &&
                    data.email === contact.contactEmail,
                ).image
              "
              alt=""
            />
            <div class="frameChild" v-else></div>
            <div class="tylerJohnsonParent">
              <div class="tylerJohnson">{{ contact.contactName }}</div>
              <div class="tylerJohnson">{{ contact.contactEmail }}</div>
            </div>
          </div>
          <img
            class="dottedIcon"
            alt=""
            src="/static/img/grey-x.svg"
            @click="removeContact(contact.id)"
          />
        </div>
      </div>
      <b class="tylerJohnson">Add billing contact</b>
      <div class="frameParent1">
        <div class="chooseFromYourMembersParent">
          <div class="tylerJohnson">Choose from your members</div>
          <hilo-select
            ref="select"
            :options="users"
            :theme="'grey'"
            :customStyle="{
              height: '40px',
              width: '100%',
              backgroundColor: '#ececec',
            }"
            v-model="selectedUserId"
          ></hilo-select>
        </div>
        <div class="chooseFromYourMembersParent">
          <div class="tylerJohnson">Or Add a billing contact by email</div>
          <input
            class="enterNameWrapper"
            placeholder="Enter email"
            v-model="contactEmail"
            :disabled="selectedUserId"
          />
        </div>
        <button
          class="addBillingContactWrapper"
          :disabled="addDisabled"
          @click="addContact"
        >
          Add billing contact
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useLoginStore } from "../../../../../../stores/loginStore";
import { getProcessedImageUrl } from "../../../../../../util/images";
import UsersAPIService from "../../../../../../servicehandlers/UsersAPIService";
import InvoiceAPIService from "../../../../../../servicehandlers/InvoiceAPIService";
import HiloSelect from "../../../../../../components/HiloComponents/HiloSelect.vue";

const usersAPIService = new UsersAPIService();
const invoiceAPIService = new InvoiceAPIService();
export default {
  name: "BillingContacts",
  components: { HiloSelect },
  data() {
    return {
      flightSchoolId: useLoginStore().getUser.flightSchoolId,
      users: [],
      contacts: [],
      selectedUserId: null,
      contactEmail: "",
    };
  },
  watch: {
    selectedUserId(newVal) {
      this.handleUserChange(newVal);
    },
  },
  async mounted() {
    await this.getPossibleUsers();
    await this.getContacts();
  },
  methods: {
    getPossibleUsers() {
      return usersAPIService
        .getAllUsersOfFlightSchool(this.flightSchoolId, this.$router)
        .then((response) => {
          for (let user of response) {
            user.name = user.firstName + " " + user.lastName;
            user.image = getProcessedImageUrl(user.image);
          }
          this.users = response;
        });
    },
    getContacts() {
      return invoiceAPIService
        .getAllInvoiceContactsForSchool(this.flightSchoolId, this.$router)
        .then((response) => {
          this.contacts = response;
        });
    },
    handleUserChange(newVal) {
      if (newVal) {
        let user = this.users.find((data) => data.id === newVal);
        this.contactEmail = user.email;
      } else {
        this.contactEmail = "";
      }
    },
    addContact() {
      let payload = {
        contactName: "",
        contactEmail: this.contactEmail,
        flightSchoolId: this.flightSchoolId,
      };

      if (this.selectedUserId) {
        payload.contactName = this.users.find(
          (data) => data.id === this.selectedUserId,
        ).name;
      } else {
        payload.contactName = this.$refs.select.searchQuery;
      }

      return invoiceAPIService
        .createInvoiceContact(payload, this.$router)
        .then(() => {
          this.getContacts();
          this.selectedUserId = null;
          this.contactEmail = "";
          this.$refs.select.searchQuery = "";
        });
    },
    removeContact(id) {
      return invoiceAPIService
        .deleteInvoiceContact(id, this.$router)
        .then(() => {
          this.getContacts();
        });
    },
  },
  computed: {
    addDisabled() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (this.contactEmail && emailRegex.test(this.contactEmail)) {
        if (this.selectedUserId) {
          return false;
        } else {
          if (this.$refs.select.searchQuery) {
            return false;
          }
        }
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.dottedIcon {
  cursor: pointer;
}
.billing-contacts {
  width: 100%;
  max-width: 780px;

  .billing-contacts_header {
    h1 {
      overflow: hidden;
      color: #404040;
      text-overflow: ellipsis;
      font-family: Helvetica, Arial, sans-serif;
      font-size: 35px;
      font-weight: 700;
      margin-bottom: 20px;
    }
  }
  .frameChild {
    width: 40px;
    position: relative;
    border-radius: 100px;
    background-color: rgba(60, 120, 255, 0.15);
    height: 40px;
  }

  .tylerJohnson {
    position: relative;
  }

  .tylerJohnsonParent {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 5px;
  }

  .frameDiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }

  .vectorIcon {
    width: 7.5px;
    position: relative;
    height: 7.5px;
  }

  .frameContainer {
    width: 650px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .frameItem {
    align-self: stretch;
    position: relative;
    max-width: 100%;
    overflow: hidden;
    max-height: 100%;
  }

  .frameGroup {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
  }

  .enterNameWrapper {
    align-self: stretch;
    border-radius: 10px;
    background-color: rgba(64, 64, 64, 0.05);
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0px 15px;
    box-sizing: border-box;
    font-size: 15px;
  }
  .enterNameWrapper:disabled {
    color: rgba(64, 64, 64, 0.5);
  }

  .chooseFromYourMembersParent {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
  }

  .addBillingContactWrapper {
    border-radius: 10px;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0px 15px;
    box-sizing: border-box;
    font-size: 15px;
  }

  .addBillingContactWrapper:disabled {
    background-color: rgba(60, 120, 255, 0.25);
    color: #fff;
  }

  .frameParent1 {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 10px;
    font-size: 13px;
  }

  .frameParent {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px 0px;
    box-sizing: border-box;
    gap: 25px;
    text-align: left;
    font-size: 15px;
    color: #404040;
    font-family: Helvetica, Arial, sans-serif;
  }
}
</style>
